export default {"src":"/_next/static/media/email.b2f119d5.svg","height":20,"width":28,"blurWidth":0,"blurHeight":0};